import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import HotelPolicyContent from '../HotelPolicyContent';

import type { HotelPolicy } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './HotelPolicyList.module.scss';

import SectionHeader from '@hotels-hotel-detail/ui/SectionHeader';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { POLICY_UBFF_ICON_MOBILE } from '@shared/ui/components/HotelPolicyMapping';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  policyList: HotelPolicy[];
  inModal?: boolean;
};

const HotelPolicyList = ({ i18n, inModal = false, policyList }: Props) => (
  <div className={cls('HotelHotelPolicyList')}>
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isActive: boolean) =>
        !isActive ? (
          <SectionHeader title={i18n.translate('Sidebar_goodToKnow')} />
        ) : null
      }
    </BpkBreakpoint>

    <div className={cls('HotelPolicyList__main')}>
      {policyList.map((policy) => (
        <div
          className={cls(
            'HotelPolicyList__policy',
            inModal && 'HotelPolicyList__mobilePolicyWithBorder',
          )}
          key={policy.type}
        >
          {policy.type && POLICY_UBFF_ICON_MOBILE[policy.type] && (
            <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
              {(isActive: boolean) =>
                isActive ? (
                  <div
                    className={cls('HotelPolicyList__policyMobileHeaderIcon')}
                  >
                    {POLICY_UBFF_ICON_MOBILE[policy.type]}
                  </div>
                ) : null
              }
            </BpkBreakpoint>
          )}
          <section className={cls('HotelPolicyList__policyText')}>
            <BpkText
              textStyle={TEXT_STYLES.heading3}
              className={cls('HotelPolicyList__policyType')}
            >
              {policy.displayName}
            </BpkText>
            <HotelPolicyContent policy={policy} />
          </section>
        </div>
      ))}
    </div>
  </div>
);

export default withI18n(HotelPolicyList);
